import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedFace.meta';

export type UseTrackClickedFaceParams = {
  location: 'image-preview' | 'people-tab';
  face_id: string;
};

export const useTrackClickedFace = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedFace = useCallback(
    (params: UseTrackClickedFaceParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedFace };
};
